import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import InviteStudentsBody from '../../../../InviteStudents/InviteStudentsBody';
import InviteStudentsContainer from '../../../../InviteStudents/InviteStudentsContainer';
import InviteStudentsHeader from '../../../../InviteStudents/InviteStudentsHeader';
import InviteStudentsNav from '../../../../InviteStudents/InviteStudentsNav';
import Loading from '../../../../InviteStudents/Loading';
import SubmitError from '../../../../InviteStudents/SubmitError';
import SubmitPartialSuccess from '../../../../InviteStudents/SubmitPartialSuccess';

type InvitesStudentsProps = {
    onCancel: () => void;
    onSuccess: () => void;
};

const InviteStudents = (props: InvitesStudentsProps) => {
    const { onSuccess } = props;
    const { ready } = useTranslation('invite_students');
    const { inviteStudentsStatus, loading } = useContainer(InviteStudentsContainer);

    useEffect(() => {
        if (inviteStudentsStatus === 'SUCCESS') {
            onSuccess();
        }
    }, [ready, loading, inviteStudentsStatus, onSuccess]);

    if (ready && !loading) {
        if (inviteStudentsStatus === 'ERROR') {
            return <SubmitError />;
        }
        if (inviteStudentsStatus === 'PARTIAL-SUCCESS') {
            return <SubmitPartialSuccess />;
        }

        return (
            <>
                <InviteStudentsHeader />
                <InviteStudentsNav />
                <InviteStudentsBody {...props} />
            </>
        );
    }

    return <Loading />;
};

export default InviteStudents;
